import React from 'react';

export default function FooterBar() {
  return (
    <footer className="footer-bar">
      <ul>
        <li>About</li>
        <li>Support</li>
        <li>FAQS</li>
      </ul>
    </footer>
  );
}
